export const rateConstant = {
    GET_BASE_RATECARD: 'GET_BASE_RATECARD',
    FETCH_ALL_COMPANY_DETAILS_PENDING : 'FETCH_ALL_COMPANY_DETAILS_PENDING',
    FETCH_ALL_COMPANY_DETAILS_SUCCESS : 'FETCH_ALL_COMPANY_DETAILS_SUCCESS',
    FETCH_ALL_COMPANY_DETAILS_FAILED : 'FETCH_ALL_COMPANY_DETAILS_FAILED',
}